import React, {useEffect, useState} from 'react';
import {useApiCreateAdminConfigs, useApiSearchAdminConfigs} from "@/api/config";
import FreeBox from "@/components/box/freeBox";
import {Alert, Button, Select} from "antd";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";


function AdminSystemConfig(props) {
    const [smsProvider, setSmsProvider] = useState('')
    const {mutate: updateConfigsMutation} = useApiCreateAdminConfigs();
    const {data: configData, isLoading: isLoadingConfigs, refetch} = useApiSearchAdminConfigs({});

    useEffect(() => {
        if (configData && configData?.data && configData?.data?.data?.length > 0) {
            configData?.data?.data?.forEach((item) => {
                if (item?.category === 'system' && item?.key === 'sms_provider') {
                    setSmsProvider(item?.value);
                }
            })
        }
    }, [configData]);

    function handleUpdateConfigsMutation() {
        updateConfigsMutation({
            'category': 'system',
            'key': 'sms_provider',
            'value': smsProvider,
        }, {
            onSuccess: (res) => {
                ApiHandleSuccessMessage(res)
            },
            onError: (err) => {
                ApiHandleErrorMessage(err)
            }
        })
    }

    const onChange = value => {
        setSmsProvider(value);
    };

    return (
        <AdminLayout pageTitle={'تننظیمات سیستمی'} backTo={URLS.admin.setting.dashboard}>

            <div>
                <FreeBox>
                    <Alert className={'my-2'}
                           message="در این صفحه تنظیمات کلی سامانه را مشاهده و ویرایش می‌کنید. لطفا مراقب باشید!"
                           type="error"/>
                    <label className={'m-2'} htmlFor="smsProvider">سرویس‌دهنده پیامک</label>

                    <Select
                        className={'mx-2'}
                        id="smsProvider"
                        defaultValue={smsProvider}
                        value={smsProvider}
                        onChange={onChange}
                        style={{width: 160}}
                        options={[
                            {value: 'kavenegar', label: <span>کاوه نگار</span>},
                            {value: 'quranrazavi_soap', label: <span>میهن اس ام اس</span>},
                            {value: 'razavi_sms_siaqh', label: <span>سیاق</span>},
                        ]}
                    />
                    <br/>
                    <div className="flex justify-end">
                        <Can permission={PermList.SETTINGS_EDIT}>
                            <Button onClick={handleUpdateConfigsMutation} type={'primary'}>ذخیره</Button>
                        </Can>
                    </div>
                </FreeBox>
            </div>
        </AdminLayout>
    );
}

export default AdminSystemConfig;